import React from "react";

// EN/AR dictionary. Falls back to EN if key missing.
const DICT = {
  en: {
    nav: { home: "HOME", properties: "PROPERTIES", zones: "ZONES", services: "SERVICES", market: "MARKET ANALYTICS", about: "ABOUT", contact: "CONTACT", list_asset: "LIST YOUR ASSET", browse: "BROWSE INVENTORY", call: "CALL" },
    hero: {
      kicker: "// 01 — DUBAI INDUSTRIAL REAL ESTATE",
      title_a: "WAREHOUSES.",
      title_b: "LOGISTICS.",
      title_c: "STRAIGHT TO BUSINESS.",
      subtitle: "Source warehouses, industrial units, industrial plots, cold storage, showrooms, staff & labour accommodation and logistics facilities across Dubai's key zones — JAFZA, DIP, Al Quoz, Ras Al Khor, Dubai South, DIC, Al Warsan Industrial and the National Industrial Park (NIP).",
      search: "SEARCH →",
      zone: "Zone", type: "Type", min_size: "Min Size (sqft)", max_price: "Max Rent (AED/yr)",
      any_zone: "Any zone", all_types: "All types",
      stat_listings: "Active Listings", stat_sqft: "Sq Ft Available", stat_zones: "Business Zones", stat_match: "Avg Match Time",
    },
    home: {
      featured_kicker: "// FEATURED INVENTORY",
      featured_title: "HAND-PICKED PROPERTIES",
      view_all: "View all inventory →",
      zones_kicker: "// 03 — KEY BUSINESS ZONES",
      zones_title_a: "WHERE DUBAI'S",
      zones_title_b: "INDUSTRY OPERATES.",
      emirates_kicker: "// 02 — EMIRATES WE COVER",
      emirates_title_a: "INVENTORY ACROSS",
      emirates_title_b: "ALL SEVEN EMIRATES.",
      emirates_sub: "Pick an emirate to filter inventory. Dubai is our core market — Abu Dhabi, Sharjah, Ajman, RAK, UAQ and Fujairah inventory is added as our acquisitions team onboards landlords.",
      categories_kicker: "// 04 — BROWSE BY CATEGORY",
      categories_title_a: "PICK YOUR",
      categories_title_b: "ASSET TYPE.",
      why_kicker: "// 05 — WHY WAREHOUSESUAE",
      why_title_a: "BUILT FOR",
      why_title_b: "OPERATORS,",
      why_title_c: "NOT TOURISTS.",
      why_sub: "We don't do glossy apartment brochures. We work with logistics directors, supply chain managers, and founders who need real estate that performs — turnover dates, power loads, dock heights, customs zones.",
      cta_kicker: "// READY TO MOVE",
      cta_title_a: "TELL US WHAT",
      cta_title_b: "YOUR OPERATION NEEDS.",
      cta_request: "REQUEST A SHORTLIST →",
      cta_whatsapp: "WHATSAPP US NOW →",
      principle_1_t: "ZONE EXPERTISE", principle_1_d: "Free zone, mainland, customs-bonded — we know which suits your trade.",
      principle_2_t: "TECHNICAL VETTING", principle_2_d: "Power, height, fire rating, loading bays — verified before viewing.",
      principle_3_t: "FAST TURNAROUND", principle_3_d: "Shortlists within 48 hours. No portal scrolling.",
      principle_4_t: "LEASE NEGOTIATION", principle_4_d: "Direct landlord access. Better terms, shorter chains.",
    },
    ai: {
      kicker: "// 02 — AI ASSISTANT",
      title_a: "DESCRIBE WHAT",
      title_b: "YOU NEED.",
      title_c: "WE'LL MATCH IT.",
      sub: "Skip the filters. Tell our AI agent in plain English (or Arabic) what your operation needs — size, zone, features, budget — and get instant matches from our live inventory.",
      try: "Try:",
      placeholder: "> describe your requirements...",
      send: "SEND ▶",
      matches: "// AI MATCHES",
      ex_1: "Need 10,000 sqft warehouse in JAFZA with loading bays",
      ex_2: "Cold storage facility for pharmaceuticals in DIP",
      ex_3: "Showroom on main road, around AED 700k/yr",
      ex_4: "Small e-commerce fulfillment space under 5000 sqft",
    },
    list_asset: {
      hero_kicker: "// FOR OWNERS",
      hero_title_a: "LIST YOUR",
      hero_title_b: "WAREHOUSE",
      hero_title_c: "WITH WAREHOUSESUAE.",
      hero_sub: "Direct landlord-to-operator placements. We market your asset to active business tenants — manufacturers, logistics, retailers — across our network and AI-powered matching engine.",
      benefits_title: "WHY LIST WITH US?",
      submit_title: "SUBMIT YOUR ASSET",
      success: "Submission received. Our acquisitions team will contact you within 24 hours.",
      b1_t: "Direct B2B Tenants", b1_d: "We work landlord-direct with operators — manufacturers, 3PL, retailers — no portal bidding wars.",
      b2_t: "AI-Matched Enquiries", b2_d: "Your asset is indexed in our AI engine. Tenants describing a fit in plain language reach you within hours.",
      b3_t: "Pre-Qualified Leads", b3_d: "We vet enquiries before they reach your team — power needs, customs zone, lease length verified up front.",
      b4_t: "Zero Listing Fees", b4_d: "Commission only on successful placement. No upfront retainer, no per-month listing fees.",
      submit_btn: "SUBMIT FOR LISTING →",
      submitting: "SUBMITTING...",
      f_name: "Your Name *", f_company: "Company", f_email: "Email *", f_phone: "Phone *",
      f_type: "Property Type *", f_zone: "Zone *", f_address: "Address *", f_size: "Total Size (sqft) *",
      f_rent: "Expected Annual Rent (AED)", f_features: "Key Features (comma-separated)", f_notes: "Additional Notes", f_images: "Property Images (optional)",
    },
    properties: {
      hero_kicker: "// INVENTORY",
      hero_title: "BROWSE PROPERTIES",
      results: "RESULTS", result: "RESULT", loading: "LOADING...",
      no_match_title: "No matches", no_match_sub: "Adjust your filters or talk to our team for off-market options.",
      filter_title: "FILTERS", reset: "Reset", search_ph: "Reference, title...",
      label_search: "Search", label_zone: "Zone", label_type: "Property Type", label_size: "Size (sqft)", label_rent: "Rent (AED/yr)", label_emirate: "Emirate",
      min: "Min", max: "Max", all_zones: "All zones", all_types: "All types", all_emirates: "All emirates",
      request_custom: "REQUEST CUSTOM SHORTLIST →",
      tab_all: "All", tab_rent: "For Rent", tab_sale: "For Sale",
    },
    detail: {
      breadcrumb_home: "Home", breadcrumb_props: "Properties",
      specs_kicker: "// SPECIFICATIONS",
      desc_kicker: "// DESCRIPTION",
      feat_kicker: "// FEATURES",
      loc_kicker: "// LOCATION",
      enq_kicker: "// REQUEST VIEWING",
      enq_submit: "SUBMIT ENQUIRY →",
      enq_submitting: "SUBMITTING...",
      wa_btn: "▶ WHATSAPP ENQUIRY",
      call_btn: "CALL +971 58 832 0669",
      per_year: "/year",
      enq_name: "Name", enq_email: "Email", enq_phone: "Phone (+971...)", enq_company: "Company (optional)", enq_msg: "Your requirements...",
      spec_type: "Property Type", spec_area: "Total Area", spec_height: "Clear Height", spec_bays: "Loading Bays", spec_power: "Power Supply", spec_parking: "Parking", spec_chiller: "Chiller", spec_office: "Office", spec_yes: "Yes", spec_no: "No", spec_included: "Included",
    },
    zones: {
      hero_kicker: "// DUBAI BUSINESS ZONES",
      hero_title_a: "WHERE YOU", hero_title_b: "SET UP MATTERS.",
      hero_sub: "Each Dubai zone has its own customs regime, licensing rules, infrastructure profile and price band. Choose the wrong one and your operation pays for it monthly.",
      view_zone: "VIEW ZONE →", view_listings: "VIEW LISTINGS →",
    },
    zone_detail: {
      back: "← All zones", kicker: "// DUBAI BUSINESS ZONE",
      stat_listings: "Available Listings", stat_sqft: "Total Sq Ft", stat_avg: "Avg AED/sqft",
      available_title: "Available Properties in",
      no_public: "No public listings right now",
      no_public_sub: "We have off-market options — get in touch.",
      request: "REQUEST SHORTLIST →",
    },
    services: {
      hero_kicker: "// WHAT WE DO",
      hero_title_a: "INDUSTRIAL", hero_title_b: "REAL ESTATE,", hero_title_c: "SOLVED.",
      cta_title: "CAN'T FIND WHAT YOU NEED?",
      cta_sub: "We source off-market properties through our direct landlord network across Dubai's industrial zones.",
      cta_btn: "REQUEST CUSTOM SOURCING →",
      s1_t: "Warehouse Leasing", s1_d: "Insulated warehouses, cross-dock facilities, bonded zones — sized from 3,000 to 100,000+ sqft.",
      s2_t: "Cold Storage", s2_d: "Chilled, frozen and blast-freezer space. GDP-compliant pharma warehousing with temperature mapping.",
      s3_t: "Industrial Units", s3_d: "Self-contained workshops with offices and yard space. Three-phase power, roller shutters, high-bay shed.",
      s4_t: "Showrooms", s4_d: "Glass-fronted retail showrooms with attached storage. High-visibility frontage on main arterial roads.",
      s5_t: "Logistics Hubs", s5_d: "Cross-dock facilities, container yards, fulfillment centres. Connected to Jebel Ali Port and DWC airport.",
      s6_t: "Storage Units", s6_d: "Compact storage from 2,000 sqft. Mezzanines, shared loading, flexible lease terms for e-commerce and SMEs.",
      s7_t: "Industrial Plots", s7_d: "Bare-land industrial plots for purpose-built warehousing, factories and storage yards. Free-zone & mainland options, sized from 10,000 sqft upward.",
      s8_t: "Staff Accommodation", s8_d: "Higher-spec staff housing — private rooms, A/C, kitchen, recreation. DM-approved, located near JAFZA, DIP, Dubai South and DIC employer hubs.",
    },
    about: {
      hero_kicker: "// ABOUT WAREHOUSESUAE",
      hero_title_a: "OPERATORS,", hero_title_b: "NOT", hero_title_c: "BROKERS.",
      hero_sub: "WarehousesUAE.com — powered by Blueworld Realestate — is a Dubai-based commercial brokerage focused exclusively on industrial property. We work with founders, supply chain managers and logistics directors — the people who actually use the space.",
      approach_kicker: "// OUR APPROACH",
      approach_title: "WE QUALIFY BEFORE WE SHOW.",
      approach_p1: "Most agencies push you through 8 viewings to \"find your fit\". We don't. We vet every property in our books for power load, clear height, fire rating, customs zone and dock configuration — before it ever appears in a shortlist.",
      approach_p2: "The result is fewer viewings, faster turnarounds, and lease terms that don't surprise you on month three.",
      stat_years: "Years in Dubai", stat_props: "Properties Vetted", stat_ret: "Lease Retention",
      principles_kicker: "// PRINCIPLES",
      principles_title: "FOUR THINGS WE DON'T COMPROMISE ON.",
      p1_t: "Technical Honesty", p1_d: "We won't sell you a 7m clear-height warehouse if you need 9m. We'll say no.",
      p2_t: "Zone Suitability", p2_d: "Mainland vs free zone vs bonded — the wrong licence costs you re-export margins.",
      p3_t: "Direct Access", p3_d: "We work landlord-direct. Fewer chains, faster handovers, cleaner contracts.",
      p4_t: "Long-term Fit", p4_d: "We optimize for your 5-year operation, not our 2-month commission cycle.",
      cta_title: "READY TO WORK WITH US?",
      cta_btn1: "CONTACT WAREHOUSESUAE →", cta_btn2: "BROWSE PROPERTIES",
    },
    contact: {
      hero_kicker: "// GET IN TOUCH",
      hero_title_a: "LET'S TALK", hero_title_b: "SPACE.",
      phone_kicker: "// PHONE", phone_hours: "Sat–Thu, 09:00–18:00 GST",
      wa_kicker: "// WHATSAPP", wa_sub: "Instant response, voice notes welcome",
      email_kicker: "// EMAIL", office_kicker: "// OFFICE",
      office_addr: "Dubai Silicon Oasis, Office #304, Donna Towers, Dubai, United Arab Emirates",
      form_kicker: "// REQUEST A SHORTLIST",
      form_title: "Tell us what you need.",
      f_name: "Your name *", f_company: "Company", f_email: "Email *", f_phone: "Phone (+971...) *",
      f_msg: "Tell us about your operation — required size, zone, power, height, lease terms, anything specific...",
      submit: "SUBMIT REQUEST →", submitting: "SUBMITTING...",
      privacy: "By submitting you agree to our handling of your enquiry under our privacy policy.",
    },
    toast: {
      enq_success: "Enquiry received — opening WhatsApp to forward it to our team.",
      enq_fail: "Could not submit. Please try WhatsApp or call us.",
      contact_success: "Enquiry received — opening WhatsApp to forward it.",
      contact_fail: "Submission failed. Please WhatsApp or call us.",
      la_fail: "Submission failed. Please contact us directly.",
      la_img_added: "image(s) added",
      la_upload_fail: "Upload failed",
      saved: "Search saved",
      removed: "Search removed",
      property_deleted: "Deleted",
      property_saved: "Property saved",
      property_updated: "Property updated",
      property_created: "Property created",
      save_fail: "Save failed",
      logged_in: "Logged in",
      invalid_creds: "Invalid credentials",
      status_updated: "Status updated",
    },
    admin_login: {
      back: "← Back to site", kicker: "// ADMIN ACCESS",
      title_a: "WAREHOUSESUAE", title_b: "CONTROL ROOM",
      email: "Email", password: "Password",
      submit: "ACCESS DASHBOARD →", submitting: "AUTHENTICATING...",
    },
    saved: {
      title: "// SAVED SEARCHES",
      empty: "No saved searches yet.",
      save_btn: "★ SAVE THIS SEARCH",
      saved_btn: "★ SAVED",
      remove: "Remove",
      prompt: "Name this search",
      default_name: "My Search",
      cancel: "Cancel",
      save: "Save",
    },
    cat: {
      warehouse: "Warehouses",
      industrial_unit: "Industrial Units",
      industrial_plot: "Industrial Plots",
      showroom: "Showrooms",
      logistics: "Logistics Hubs",
      storage: "Storage Units",
      staff_accommodation: "Staff & Labour Accommodation",
    },
  },
  ar: {
    nav: { home: "الرئيسية", properties: "العقارات", zones: "المناطق", services: "الخدمات", market: "تحليلات السوق", about: "من نحن", contact: "تواصل", list_asset: "اعرض عقارك", browse: "تصفح المخزون", call: "اتصل" },
    hero: {
      kicker: "// ٠١ — العقارات الصناعية في دبي",
      title_a: "مستودعات.",
      title_b: "خدمات لوجستية.",
      title_c: "مباشرة للأعمال.",
      subtitle: "استأجر مستودعات ووحدات صناعية وأراضي صناعية ومخازن مبردة وصالات عرض وسكن موظفين وعمال ومرافق لوجستية في مناطق دبي الرئيسية — جافزا، DIP، القوز، رأس الخور، دبي الجنوب، DIC، الورسان الصناعية والمنطقة الصناعية الوطنية (NIP).",
      search: "بحث →",
      zone: "المنطقة", type: "النوع", min_size: "أدنى مساحة (قدم²)", max_price: "أقصى إيجار (د.إ/سنة)",
      any_zone: "أي منطقة", all_types: "كل الأنواع",
      stat_listings: "قوائم نشطة", stat_sqft: "قدم² متاح", stat_zones: "مناطق أعمال", stat_match: "متوسط زمن المطابقة",
    },
    home: {
      featured_kicker: "// المختارة",
      featured_title: "عقارات مختارة بعناية",
      view_all: "عرض كل المخزون →",
      zones_kicker: "// ٠٣ — مناطق الأعمال الرئيسية",
      zones_title_a: "حيث تعمل",
      zones_title_b: "صناعة دبي.",
      emirates_kicker: "// ٠٢ — الإمارات التي نغطيها",
      emirates_title_a: "إنفنتري عبر",
      emirates_title_b: "الإمارات السبع.",
      emirates_sub: "اختر إمارة لتصفية العقارات. دبي هي سوقنا الأساسي — يتم إضافة المخزون في أبوظبي والشارقة وعجمان ورأس الخيمة وأم القيوين والفجيرة مع توسع فريق الاستحواذ.",
      categories_kicker: "// ٠٤ — تصفح حسب الفئة",
      categories_title_a: "اختر",
      categories_title_b: "نوع الأصل.",
      why_kicker: "// ٠٥ — لماذا WarehousesUAE",
      why_title_a: "مصمم",
      why_title_b: "للعمليات،",
      why_title_c: "لا للسياح.",
      why_sub: "نحن لا نروج كتيبات شقق لامعة. نعمل مع مديري الخدمات اللوجستية والمشتريات ومؤسسي الشركات الذين يحتاجون عقارات تعمل — تواريخ التسليم، حمل الطاقة، ارتفاع المنصات، المناطق الجمركية.",
      cta_kicker: "// جاهز للانتقال",
      cta_title_a: "أخبرنا",
      cta_title_b: "بما تحتاجه عمليتك.",
      cta_request: "اطلب قائمة مختارة →",
      cta_whatsapp: "تواصل عبر واتساب →",
      principle_1_t: "خبرة بالمناطق", principle_1_d: "منطقة حرة، البر الرئيسي، جمركية — نعرف ما يناسب نشاطك.",
      principle_2_t: "تدقيق فني", principle_2_d: "الطاقة، الارتفاع، تصنيف الحريق، أرصفة التحميل — جميعها متحققة قبل المعاينة.",
      principle_3_t: "إنجاز سريع", principle_3_d: "قوائم مختارة خلال ٤٨ ساعة. لا تصفح مطول للبوابات.",
      principle_4_t: "تفاوض الإيجار", principle_4_d: "وصول مباشر للمالك. شروط أفضل وسلاسل أقصر.",
    },
    ai: {
      kicker: "// ٠٢ — المساعد الذكي",
      title_a: "صف ما",
      title_b: "تحتاجه.",
      title_c: "سنطابقه لك.",
      sub: "تخطَّ الفلاتر. أخبر مساعدنا الذكي ما تحتاجه عملياتك — المساحة، المنطقة، المواصفات، الميزانية — واحصل على نتائج فورية من مخزوننا.",
      try: "جرّب:",
      placeholder: "› اكتب متطلباتك...",
      send: "إرسال ▶",
      matches: "// المطابقات الذكية",
      ex_1: "أحتاج مستودع ١٠٬٠٠٠ قدم² في جافزا مع أرصفة تحميل",
      ex_2: "منشأة تخزين بارد للأدوية في DIP",
      ex_3: "صالة عرض على شارع رئيسي، حوالي ٧٠٠ ألف د.إ/سنة",
      ex_4: "مساحة صغيرة للتجارة الإلكترونية أقل من ٥٠٠٠ قدم²",
    },
    list_asset: {
      hero_kicker: "// لأصحاب العقارات",
      hero_title_a: "اعرض",
      hero_title_b: "مستودعك",
      hero_title_c: "مع WarehousesUAE.",
      hero_sub: "نضع المالكين مباشرة أمام المستأجرين النشطين — الشركات الصناعية والخدمات اللوجستية والتجزئة — عبر شبكتنا ومحرك المطابقة الذكي.",
      benefits_title: "لماذا تعرض معنا؟",
      submit_title: "قدّم عقارك",
      success: "تم استلام طلبك. سيتواصل فريق الاستحواذ معك خلال ٢٤ ساعة.",
      b1_t: "مستأجرون مباشرون", b1_d: "نعمل مباشرة مع المالك والشركات التشغيلية — مصانع، لوجستيات، تجزئة — بدون مزادات بوابات.",
      b2_t: "استفسارات بالذكاء", b2_d: "عقارك مفهرس في محرك الذكاء لدينا. المستأجرون يصلونك خلال ساعات.",
      b3_t: "عملاء مؤهلون", b3_d: "نتحقق من الاستفسارات قبل وصولها لفريقك — متطلبات الطاقة، المنطقة الجمركية، مدة الإيجار.",
      b4_t: "بدون رسوم إدراج", b4_d: "عمولة فقط عند الإيجار الناجح. لا رسوم مقدمة ولا رسوم شهرية.",
      submit_btn: "قدّم للإدراج →",
      submitting: "جاري الإرسال...",
      f_name: "اسمك *", f_company: "الشركة", f_email: "البريد الإلكتروني *", f_phone: "الهاتف *",
      f_type: "نوع العقار *", f_zone: "المنطقة *", f_address: "العنوان *", f_size: "المساحة الإجمالية (قدم²) *",
      f_rent: "الإيجار السنوي المتوقع (د.إ)", f_features: "الميزات الرئيسية (مفصولة بفاصلة)", f_notes: "ملاحظات إضافية", f_images: "صور العقار (اختياري)",
    },
    properties: {
      hero_kicker: "// المخزون",
      hero_title: "تصفح العقارات",
      results: "نتيجة", result: "نتيجة", loading: "جاري التحميل...",
      no_match_title: "لا توجد مطابقات", no_match_sub: "عدّل الفلاتر أو تواصل مع فريقنا لخيارات خارج السوق.",
      filter_title: "الفلاتر", reset: "إعادة", search_ph: "المرجع، العنوان...",
      label_search: "بحث", label_zone: "المنطقة", label_type: "النوع", label_size: "المساحة (قدم²)", label_rent: "الإيجار (د.إ/سنة)", label_emirate: "الإمارة",
      min: "أدنى", max: "أعلى", all_zones: "كل المناطق", all_types: "كل الأنواع", all_emirates: "كل الإمارات",
      request_custom: "اطلب قائمة مخصصة →",
      tab_all: "الكل", tab_rent: "للإيجار", tab_sale: "للبيع",
    },
    detail: {
      breadcrumb_home: "الرئيسية", breadcrumb_props: "العقارات",
      specs_kicker: "// المواصفات",
      desc_kicker: "// الوصف",
      feat_kicker: "// الميزات",
      loc_kicker: "// الموقع",
      enq_kicker: "// طلب معاينة",
      enq_submit: "إرسال الاستفسار →",
      enq_submitting: "جاري الإرسال...",
      wa_btn: "▶ استفسار عبر واتساب",
      call_btn: "اتصل ٠٦٦٩ ٨٣٢ ٥٨ ٩٧١+",
      per_year: "/سنة",
      enq_name: "الاسم", enq_email: "البريد الإلكتروني", enq_phone: "الهاتف (+971...)", enq_company: "الشركة (اختياري)", enq_msg: "متطلباتك...",
      spec_type: "نوع العقار", spec_area: "المساحة الإجمالية", spec_height: "الارتفاع الصافي", spec_bays: "أرصفة التحميل", spec_power: "الطاقة", spec_parking: "موقف", spec_chiller: "تبريد", spec_office: "مكتب", spec_yes: "نعم", spec_no: "لا", spec_included: "مشمول",
    },
    zones: {
      hero_kicker: "// مناطق الأعمال في دبي",
      hero_title_a: "أين تقيم", hero_title_b: "يحدد المسار.",
      hero_sub: "لكل منطقة في دبي نظام جمارك ولوائح ترخيص وبنية تحتية ونطاق سعر مختلف. الاختيار الخاطئ يُكلّفك شهرياً.",
      view_zone: "عرض المنطقة →", view_listings: "عرض القوائم →",
    },
    zone_detail: {
      back: "← كل المناطق", kicker: "// منطقة أعمال في دبي",
      stat_listings: "قوائم متاحة", stat_sqft: "إجمالي القدم²", stat_avg: "متوسط د.إ/قدم²",
      available_title: "العقارات المتاحة في",
      no_public: "لا توجد قوائم عامة حالياً",
      no_public_sub: "لدينا خيارات خارج السوق — تواصل معنا.",
      request: "اطلب قائمة مختارة →",
    },
    services: {
      hero_kicker: "// ما نقدمه",
      hero_title_a: "العقارات", hero_title_b: "الصناعية،", hero_title_c: "محلولة.",
      cta_title: "لم تجد ما تحتاج؟",
      cta_sub: "نوفر عقارات خارج السوق عبر شبكتنا المباشرة من الملاك في مناطق دبي الصناعية.",
      cta_btn: "اطلب استكشاف مخصص →",
      s1_t: "تأجير المستودعات", s1_d: "مستودعات معزولة ومرافق تحميل عابرة ومناطق جمركية — من ٣٬٠٠٠ إلى أكثر من ١٠٠٬٠٠٠ قدم².",
      s2_t: "التخزين البارد", s2_d: "مساحات مبردة ومجمدة ومجمد سريع. مستودعات GDP للأدوية مع رسم خرائط الحرارة.",
      s3_t: "وحدات صناعية", s3_d: "ورش مستقلة بمكاتب وساحات. طاقة ثلاثية الأطوار، أبواب دلفنية، سقف عالٍ.",
      s4_t: "صالات عرض", s4_d: "صالات عرض زجاجية مع تخزين خلفي. واجهات بارزة على شوارع رئيسية.",
      s5_t: "مراكز لوجستية", s5_d: "تحميل عابر وساحات حاويات ومراكز توزيع. متصلة بميناء جبل علي ومطار آل مكتوم.",
      s6_t: "وحدات تخزين", s6_d: "تخزين مدمج من ٢٬٠٠٠ قدم². ميزانين، تحميل مشترك، شروط مرنة للتجارة الإلكترونية والمتوسطة.",
      s7_t: "أراضٍ صناعية", s7_d: "قطع أراضٍ صناعية لبناء مستودعات ومصانع وساحات تخزين مخصصة. خيارات في المناطق الحرة والبر الرئيسي، من ١٠٬٠٠٠ قدم² وأكثر.",
      s8_t: "سكن للموظفين", s8_d: "سكن موظفين بمواصفات عالية — غرف خاصة، تكييف، مطبخ، ترفيه. معتمد من البلدية، قريب من جافزا وDIP ودبي الجنوب وDIC.",
    },
    about: {
      hero_kicker: "// عن WarehousesUAE",
      hero_title_a: "مشغّلون،", hero_title_b: "لا", hero_title_c: "وسطاء.",
      hero_sub: "WarehousesUAE.com — مدعومة من Blueworld Realestate — وساطة تجارية في دبي متخصصة حصرياً بالعقارات الصناعية. نعمل مع المؤسسين ومديري سلاسل الإمداد واللوجستيات — أولئك الذين يستخدمون المساحة فعلياً.",
      approach_kicker: "// نهجنا",
      approach_title: "نتحقق قبل أن نعرض.",
      approach_p1: "معظم الوكالات تقودك لـ ٨ معاينات لتجد \"المناسب\". نحن لا. نتحقق من كل عقار في سجلاتنا — حمل الطاقة، الارتفاع، تصنيف الحريق، المنطقة الجمركية، إعداد الأرصفة — قبل أن يدخل القائمة المختارة.",
      approach_p2: "النتيجة: معاينات أقل، إنجاز أسرع، وشروط إيجار لا تفاجئك في الشهر الثالث.",
      stat_years: "سنوات في دبي", stat_props: "عقارات متحققة", stat_ret: "احتفاظ بالإيجار",
      principles_kicker: "// مبادئنا",
      principles_title: "أربعة أمور لا نتنازل عنها.",
      p1_t: "صدق فني", p1_d: "لن نبيعك مستودعاً بارتفاع ٧م إذا احتجت ٩م. سنرفض ببساطة.",
      p2_t: "ملاءمة المنطقة", p2_d: "بر رئيسي أو منطقة حرة أو جمركية — الترخيص الخاطئ يُكلّفك هوامش إعادة التصدير.",
      p3_t: "وصول مباشر", p3_d: "نعمل مباشرة مع الملاك. سلاسل أقصر، تسليم أسرع، عقود أنظف.",
      p4_t: "ملاءمة طويلة الأمد", p4_d: "نحسن لعمليتك على خمس سنوات، لا لدورة عمولتنا الشهرية.",
      cta_title: "جاهز للعمل معنا؟",
      cta_btn1: "تواصل مع WarehousesUAE →", cta_btn2: "تصفح العقارات",
    },
    contact: {
      hero_kicker: "// تواصل معنا",
      hero_title_a: "لنتحدث", hero_title_b: "عن المساحة.",
      phone_kicker: "// الهاتف", phone_hours: "السبت–الخميس، ٠٩:٠٠–١٨:٠٠ بتوقيت الخليج",
      wa_kicker: "// واتساب", wa_sub: "رد فوري، الرسائل الصوتية مرحب بها",
      email_kicker: "// البريد", office_kicker: "// المكتب",
      office_addr: "واحة دبي للسيليكون، مكتب رقم ٣٠٤، أبراج دونا، دبي، الإمارات العربية المتحدة",
      form_kicker: "// اطلب قائمة مختارة",
      form_title: "أخبرنا بما تحتاجه.",
      f_name: "اسمك *", f_company: "الشركة", f_email: "البريد *", f_phone: "الهاتف (+971...) *",
      f_msg: "أخبرنا عن عمليتك — المساحة المطلوبة، المنطقة، الطاقة، الارتفاع، شروط الإيجار، أي تفاصيل خاصة...",
      submit: "إرسال الطلب →", submitting: "جاري الإرسال...",
      privacy: "بتقديم الطلب فأنت توافق على معالجة استفسارك وفق سياسة الخصوصية.",
    },
    toast: {
      enq_success: "تم استلام الاستفسار — جارٍ فتح واتساب لإرساله إلى فريقنا.",
      enq_fail: "تعذّر الإرسال. الرجاء استخدام واتساب أو الاتصال بنا.",
      contact_success: "تم استلام الاستفسار — جارٍ فتح واتساب.",
      contact_fail: "فشل الإرسال. الرجاء استخدام واتساب أو الاتصال بنا.",
      la_fail: "فشل الإرسال. الرجاء التواصل معنا مباشرة.",
      la_img_added: "صورة مضافة",
      la_upload_fail: "فشل رفع الصورة",
      saved: "تم حفظ البحث",
      removed: "تم إزالة البحث",
      property_deleted: "تم الحذف",
      property_saved: "تم حفظ العقار",
      property_updated: "تم تحديث العقار",
      property_created: "تم إنشاء العقار",
      save_fail: "فشل الحفظ",
      logged_in: "تم تسجيل الدخول",
      invalid_creds: "بيانات اعتماد خاطئة",
      status_updated: "تم تحديث الحالة",
    },
    admin_login: {
      back: "← العودة للموقع", kicker: "// وصول المسؤول",
      title_a: "WarehousesUAE", title_b: "لوحة التحكم",
      email: "البريد الإلكتروني", password: "كلمة المرور",
      submit: "الوصول للوحة التحكم →", submitting: "جاري المصادقة...",
    },
    saved: {
      title: "// عمليات البحث المحفوظة",
      empty: "لا توجد عمليات بحث محفوظة بعد.",
      save_btn: "★ احفظ هذا البحث",
      saved_btn: "★ محفوظ",
      remove: "إزالة",
      prompt: "سمِّ عملية البحث",
      default_name: "بحثي",
      cancel: "إلغاء",
      save: "حفظ",
    },
    cat: {
      warehouse: "مستودعات",
      industrial_unit: "وحدات صناعية",
      industrial_plot: "أراضٍ صناعية",
      showroom: "صالات عرض",
      logistics: "مراكز لوجستية",
      storage: "وحدات تخزين",
      staff_accommodation: "سكن الموظفين والعمال",
    },
  },
};

const LangCtx = React.createContext({ lang: "en", setLang: () => {}, t: (k) => k, dir: "ltr" });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = React.useState(() => localStorage.getItem("bw_lang") || "en");

  const setLang = (l) => {
    localStorage.setItem("bw_lang", l);
    setLangState(l);
  };

  React.useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = React.useCallback((path) => {
    const parts = path.split(".");
    let cur = DICT[lang];
    for (const p of parts) {
      if (cur && typeof cur === "object") cur = cur[p];
      else { cur = undefined; break; }
    }
    if (cur === undefined) {
      let en = DICT.en;
      for (const p of parts) en = en?.[p];
      return en || path;
    }
    return cur;
  }, [lang]);

  const value = React.useMemo(() => ({ lang, setLang, t, dir: lang === "ar" ? "rtl" : "ltr" }), [lang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useT = () => React.useContext(LangCtx);
